export const ClaveSNServicio = [
    {
        nombreEnvio: "snEnvioSat",
        nombreProceso: "ENVIO A SAT"
    }, {
        nombreEnvio: "snReciboSat",
        nombreProceso: "RECIBO DE SAT"
    }, {
        nombreEnvio: "snEncriptarEnvioSat",
        nombreProceso: "ENCRIPTAR ENVIO"
    }, {
        nombreEnvio: "snEncriptarReciboSat",
        nombreProceso: "DESENCRIPTAR RECIBO"
    }, {
        nombreEnvio: "snGestionable",
        nombreProceso: "ES GESTIONABLE"
    }];

export const nombreEnvio = (nombreProceso: string) => {
    return ClaveSNServicio.find(tipo => tipo.nombreProceso === nombreProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/modelo/ClaveSNServicio.ts